export const breakpoints = {
  xs: 400,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 2300,
};

export const min = {
  xs: `@media (min-width: ${breakpoints.xs}px)`,
  sm: `@media (min-width: ${breakpoints.sm}px)`,
  md: `@media (min-width: ${breakpoints.md}px)`,
  lg: `@media (min-width: ${breakpoints.lg}px)`,
  xl: `@media (min-width: ${breakpoints.xl}px)`,
  xxl: `@media (min-width: ${breakpoints.xxl}px)`,
};

export const max = {
  xs: `@media (max-width: ${breakpoints.xs - 1}px)`,
  sm: `@media (max-width: ${breakpoints.sm - 1}px)`,
  md: `@media (max-width: ${breakpoints.md - 1}px)`,
  lg: `@media (max-width: ${breakpoints.lg - 1}px)`,
  xl: `@media (max-width: ${breakpoints.xl - 1}px)`,
  xxl: `@media (max-width: ${breakpoints.xxl - 1}px)`,
};
